<template>
  <main>
    <v-container class="booking-table">
      <v-toolbar flat class="main-header mb-6">
        <v-toolbar-title class="main-header__title">
          <h1>Bus Locations</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items
          v-if="permissions.includes('store_api_admin-panel_bus-locations')"
          class="main-header__contents"
        >
          <v-btn
            class="my-auto mx-1 radius-12"
            color="success"
            to="/bus-locations/create"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add Bus Location</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />
      <v-data-table
        v-model="selected"
        hide-default-footer
        :single-select="singleSelect"
        :headers="busLocationsTableHeaders"
        :items="busLocations"
        :mobile-breakpoint="zero"
        :items-per-page="1000"
        class="table"
        :single-expand="expanding"
        :expanded.sync="expanded"
        show-expand
        item-key="id"
        :loading="loadingBusLocations"
      >
        <template v-slot:item.actions="{ item, index }">
          <router-link
            :to="{ name: 'busLocationEdit', params: { id: item.id } }"
            v-if="
              permissions.includes(
                'update_api_admin-panel_bus-locations_{bus_location}'
              )
            "
            title="Edit"
          >
            <v-icon small class="mr-2">
              mdi-pencil
            </v-icon>
          </router-link>
          <template
            v-if="
              permissions.includes(
                'destroy_api_admin-panel_bus-locations_{bus_location}'
              )
            "
          >
            <v-icon
              v-if="item.can_delete == true"
              small
              @click="handleDelete(item, index)"
            >
              mdi-delete
            </v-icon>
          </template>
          <span v-else></span>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td
            v-if="permissions.includes('index_api_admin-panel_bus-stops')"
            :colspan="busLocationsTableHeaders.length + 1"
            class="px-0 py-0"
          >
            <section
              v-if="item.bus_stops.length > 0"
              class="pa-4 table-head-border"
            >
              <h2>Bus Stops</h2>
              <v-list>
                <v-list-item
                  v-for="bus_location in item.bus_stops"
                  :key="bus_location.id"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">mdi-circle</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ bus_location.stop_point_name }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title
                      ><span>Return Time : </span>
                      <strong>{{
                        bus_location.return_time
                      }}</strong></v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title
                      ><span>Stop Time : </span>
                      <strong>{{
                        bus_location.stop_time
                      }}</strong></v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </section>
            <h4 v-else class="text-center color-primary">
              No Available Bus Locations
            </h4>
          </td>
        </template>
      </v-data-table>
    </v-container>
  </main>
</template>

<script>
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      busLocations: [],
      busLocationsTableHeaders: [
        {
          text: "Name",
          sortable: false,
          value: "start_point"
        },
        {
          text: "Capacity",
          align: "center",
          sortable: false,
          value: "capacity"
        },
        {
          text: "Bus No",
          align: "center",
          sortable: false,
          value: "bus_no"
        },
        { text: "", value: "actions", align: "center", sortable: false },
        { text: "", value: "data-table-expand" }
      ],
      expanding: true,
      loadingBusLocations: false,
      expanded: [],
      zero: 0,
      selected: [],
      singleSelect: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.indexBusLocations();
    console.log(this.$router);
  },
  methods: {
    indexBusLocations(query) {
      this.loadingBusLocations = true;
      IndexData({ reqName: "bus-locations", query })
        .then(res => {
          const { data } = res.data;
          this.busLocations = data;
          this.loadingBusLocations = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/bus-locations/destroy`,
            id: id
          })
            .then(() => {
              this.busLocations.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
